import { motion } from "framer-motion";
import { SectionLabel } from "@/components/SectionLabel";
import { WordReveal } from "@/components/WordReveal";
import { courses, type Course } from "@/content/teaching";

export function Teaching() {
  return (
    <section
      id="teaching"
      className="border-t border-line px-6 py-20 md:px-10 lg:px-16"
      aria-labelledby="teaching-h"
    >
      <header className="mx-auto mb-16 max-w-7xl">
        <SectionLabel index={3}>Undervisning</SectionLabel>
        <WordReveal
          as="h2"
          id="teaching-h"
          className="mt-5 block font-display text-5xl font-normal leading-[1.02] md:text-6xl"
        >
          Undervisning og veiledning
        </WordReveal>
      </header>
      <ul className="mx-auto grid max-w-7xl gap-5 lg:grid-cols-3">
        {courses.map((course, i) => (
          <CourseCard key={course.code} course={course} index={i} />
        ))}
      </ul>
    </section>
  );
}

function CourseCard({ course, index }: { course: Course; index: number }) {
  return (
    <motion.li
      className="card-lift relative border border-line bg-panel p-7"
      initial={{ opacity: 0, y: 10 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.4, delay: index * 0.05 }}
    >
      <div className="flex items-center justify-between">
        <span className="font-mono text-[0.65rem] uppercase tracking-widest text-muted">
          {course.current ? (
            <span className="text-fg">Aktuelt · {course.term}</span>
          ) : (
            <>Tidligere · {course.term}</>
          )}
        </span>
        <span className="font-mono text-[0.65rem] uppercase tracking-widest text-muted">
          {course.level}
        </span>
      </div>
      <h3 className="mt-5 font-display text-3xl font-normal text-fg">{course.code}</h3>
      <p className="mt-1 text-sm text-muted">{course.title}</p>
      <p className="mt-5 text-sm leading-relaxed text-muted">{course.description}</p>
      <div className="mt-7 flex items-center justify-between gap-4">
        <span className="font-mono text-[0.65rem] uppercase tracking-widest text-muted">
          {course.role}
        </span>
        <a
          href={course.href}
          className="font-mono text-xs uppercase tracking-widest text-accent hover:underline focus-visible:underline focus-visible:outline-none"
        >
          Les mer →
        </a>
      </div>
    </motion.li>
  );
}
